import React from 'react';
import PropTypes from 'prop-types';
import Dialog from "../overlay/Dialog";
import OverlayController from '../overlay/OverlayController';
import TextField from "../material/TextField";
import userContext from "../../services/userContext";
import mutations from "../../graphql/mutations";
import { compose } from 'react-apollo';
import './AccountSettings.css';

export default compose(
    mutations.updateUserNameHoc
)(class AccountSettings extends React.Component {

    static propTypes = {
        updateUserName: PropTypes.func.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.onUserNameChange = this.onUserNameChange.bind(this);
        this.didClickSave = this.didClickSave.bind(this);

        this.state = {
            userName: userContext.getCurrentUser().name || ''
        };
    }

    onUserNameChange(event) {
        this.setState({
            userName: event.target.value
        });
    }

    didClickSave() {
        OverlayController.showActivityIndicator();
        this.props.updateUserName(this.state.userName)
            .then(user => {
                console.log('changed user name', user);
                OverlayController.hideActivityIndicator();
                OverlayController.hideOverlay();
            })
            .catch((error) => {
                console.log('there was an error sending the query', error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    render() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Save', handler: this.didClickSave.bind(this)}
        ];
        return (
            <Dialog title="Account Settings" actions={actions}>
                <div className="accountSettings">
                    <TextField className="accountSettingsEmailField" disabled={true} floatingLabel={true} labelText={"Email"} value={userContext.getCurrentUser().email}/>
                    <TextField className="accountSettingsNameField" floatingLabel={true} labelText={"Name"} value={this.state.userName} onChange={this.onUserNameChange}/>
                </div>
            </Dialog>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account/AccountSettings.js